"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LESSON_TYPE_ORDER = exports.getLessonTypeForCode = exports.locations = exports.Weekday2Number = exports.daysOrder = exports.getCanBeRemoteForLessonType = exports.getCapacityForLessonType = void 0;
const types_1 = require("../types");
const getCapacityForLessonType = (lessonType) => {
    switch (lessonType) {
        case types_1.LessonType.KI:
            return 1;
        case types_1.LessonType.K8:
        case types_1.LessonType.KM:
        case types_1.LessonType.KG:
            return 6;
        case types_1.LessonType.WS:
            return 12; //temporary value (unchecked against business logic)
    }
};
exports.getCapacityForLessonType = getCapacityForLessonType;
const getCanBeRemoteForLessonType = (lessonType) => {
    return lessonType === types_1.LessonType.KI;
};
exports.getCanBeRemoteForLessonType = getCanBeRemoteForLessonType;
exports.daysOrder = [types_1.Weekday.Mon, types_1.Weekday.Tue, types_1.Weekday.Wed, types_1.Weekday.Thu, types_1.Weekday.Fri, types_1.Weekday.Sat, types_1.Weekday.Sun];
// Dayjs day of week numeration
const Weekday2Number = (day) => {
    switch (day) {
        case types_1.Weekday.Sun:
            return 0;
        case types_1.Weekday.Mon:
            return 1;
        case types_1.Weekday.Tue:
            return 2;
        case types_1.Weekday.Wed:
            return 3;
        case types_1.Weekday.Thu:
            return 4;
        case types_1.Weekday.Fri:
            return 5;
        case types_1.Weekday.Sat:
            return 6;
        default:
            return -1;
    }
};
exports.Weekday2Number = Weekday2Number;
exports.locations = [types_1.Location.Lanciego, types_1.Location.Cynamonowa, types_1.Location.Online];
/** @deprecated Use offer.lessonType instead */
const getLessonTypeForCode = (code) => {
    if (code.includes('warsztaty'))
        return types_1.LessonType.WS;
    if (code.includes('8K'))
        return types_1.LessonType.K8;
    if (code.includes('ind'))
        return types_1.LessonType.KI;
    if (code.includes('grupa'))
        return types_1.LessonType.KG;
    if (code.includes('kurs MR') || code.includes('kurs MP'))
        return types_1.LessonType.KM;
    return undefined;
};
exports.getLessonTypeForCode = getLessonTypeForCode;
exports.LESSON_TYPE_ORDER = [types_1.LessonType.KI, types_1.LessonType.KG, types_1.LessonType.K8, types_1.LessonType.KM, types_1.LessonType.WS];
